export default __webpack_public_path__ + "static/media/problemasconregistro_daclick.0aca89ad.png";